import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-hot-toast';
import { useCart } from "react-use-cart";
import Header from '../components/Header';
import axiosInstance from '../../axiosInstance';
import getCookie from '../../helper/getCookie';
import HeaderPage from '../components/HeaderPage';
import getDecryptData from '../../helper/getDecryptData';


const WishList = () => {

  const [isCat, setIsCat] = useState(true);
  const [Wishlist, setWishlist] = useState([]);

  const { addItem } = useCart();

  const getWishlist = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    try {
      const { data } = await axiosInstance.get(`/view-wishlist/${id}`);
      console.log("wishlist", data);
      setWishlist(data.wishlist);
      setIsCat(false);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      setIsCat(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/delete-wishlist/${id}`);
      toast.success("Deleted from wishlist successfully");
      getWishlist();
    } catch (error) {
      console.error('Error deleting wishlist item:', error);
    }
  };

  const handleAddToCart = (product) => {
    addItem({
      id: product._id,
      name: product.title,
      price: product.salePrice,
      image: product.pImage,
    });
    toast.success("Added to cart");
  };

  useEffect(() => {
    getWishlist();
  }, []);

  return (
    <>
      <HeaderPage title={'Wishlist'} />

      <main className="page-content mypadding  overflow-auto pb-4">
        <div className="px-3">
          <div className="row">

            {isCat
              ? Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="col-md-3 col-sm-6 mt-4">
                  <div className="card-1 skeleton" style={{ height: 430, borderRadius: 5 }}></div>
                </div>
              ))
              : Wishlist.length === 0
                ? (
                  <div className="col-12 text-center py-5">
                    <i className="ri-heart-line" style={{ fontSize: 48, color: '#ccc' }} />
                    <p className="mt-3 text-gold">Your wishlist is empty.</p>
                  </div>
                )
                : Wishlist.slice().reverse().map((Pro) => {
                  const product = Pro.productDetail;
                  if (!product) return null;

                  const discount = product.regularPrice
                    ? Math.round(((product.regularPrice - product.salePrice) / product.regularPrice) * 100)
                    : null;

                  return (
                    <div key={Pro._id} className="col-md-3 col-sm-6 mt-4">
                      <div className="dz-card">
                        <div className="dz-media">
                          <Link to={`/product/${Pro.slug || product._id}`}>
                            <img src={product.pImage} alt={product.title} />
                          </Link>
                          <button
                            type="button"
                            className="item-bookmark"
                            onClick={() => handleDelete(Pro._id)}
                            title="Remove from wishlist"
                          >
                            <i className="feather icon-heart" style={{ color: '#e74c3c' }} />
                          </button>
                        </div>
                        <div className="dz-content">
                          <h5 className="title truncate-two-lines">
                            <Link to={`/product/${Pro.slug || product._id}`}>
                              {product.title}
                            </Link>
                          </h5>
                          <div className="dz-price">
                            ₹{product.salePrice}
                            {product.regularPrice && (
                              <del>₹{product.regularPrice}</del>
                            )}
                          </div>
                          {discount > 0 && (
                            <div className="dz-off">{discount}% Off</div>
                          )}
                          <div className="d-flex gap-2 mt-2">

                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(Pro._id)}
                              title="Remove from wishlist"
                            >
                              <i className="ri-delete-bin-line me-2" /> {' '} remove
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

          </div>
        </div>
      </main>
    </>
  );
};

export default WishList;